import { LayerReferenceItem } from "./types";

export default function isValidLayerReference(layerReference: LayerReferenceItem): boolean {
  const { targetAttribute, layerName, referenceAttribute } = layerReference;

  return !!(targetAttribute && layerName && referenceAttribute);
}
